module.exports = __webpack_public_path__ + "static/media/checkbox-check.ff400e44.svg";